import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from '../api/services/authentication.service';

/**
 * Marker header that tells the AuthInterceptor to skip attaching the
 * `Authorization` header for this request (e.g. a presigned S3 upload, which
 * is rejected by S3 when an extra Authorization header is present). The header
 * is stripped before the request leaves the app.
 */
export const SKIP_AUTH_HEADER = 'X-Skip-Auth';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.has(SKIP_AUTH_HEADER)) {
      const skipAuthRequest = request.clone({
        headers: request.headers.delete(SKIP_AUTH_HEADER)
      });
      return next.handle(skipAuthRequest);
    }

    const token = this.authService.getSessionToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              // TODO: Throw auth error using auth service
              this.authService.throwAuthError('Access denied');
            }
          }
        }
      )
    );
  }
}
